module.exports = __webpack_public_path__ + "static/media/splash-crop-transparent.097d4935.png";